import React, { useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Button, Box, Dialog, DialogContent, Stack, Typography, Modal, Tooltip as TT, IconButton, ButtonGroup, Grid, Card, CardHeader, CardContent } from '@mui/material'


import { selectViewInstanceById } from '../../../reducers/reuseable_vi';
import ProfileDemographics from './ProfileDemographics';

const ProfileDemographicsCard = (props) => {
    const viewInstance = useSelector(state => selectViewInstanceById(state, "ProfileDemographics"))

    return (
        <Grid container direction="row" alignItems={"center"} justifyContent={"center"} spacing={2} mt={2}>
            <Grid item xs={12}>
                <Typography variant="h5">{viewInstance.ProfileVI.MenuProfile.ProfileGreeting}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="subtitle1">{viewInstance.ProfileVI.MenuProfile.ProfileSubgreeting}</Typography>
            </Grid>
            <Grid item xs={12}>
                <ProfileDemographics />
            </Grid>
        </Grid>


    )

}

export default ProfileDemographicsCard